import { defineSlotRecipe } from '@chakra-ui/react'

export const snackbar = defineSlotRecipe({
  className: 'Snackbar',
  slots: ['button', 'closeButton', 'container', 'description', 'icon', 'title'],
  base: {
    container: {
      bgColor: 'brand.cloudWhite',
      borderColor: 'brand.primaryBlue',
    },
  },
  variants: {
    variant: {
      promo: {
        container: {
          borderColor: 'brand.highlight.blue',
          svg: {
            color: 'brand.highlight.blue',
          },
          'p:first-child': {
            fontWeight: 'normal',
            pb: 2,
          },
          strong: {
            fontWeight: 'normal',
          },
        },
      },
    },
  },
})
